import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import ISessionService from "../../services/auth/ISessionService";
import Vue from "vue";

export class AuthCheckVue extends Vue {
  /**Сервис сессии */
  sessionService: ISessionService = container.get<ISessionService>(
    DiTokens.SessionService
  );

  checkAuthInterval: number = 0;

  /**Проверяем авторизацию */
  checkAuth() {
    this.sessionService.sessionPing(true, true, true);
  }

  async init() {
    this.checkAuthInterval = setInterval(async () => {
      await this.sessionService.sessionPing(true, false, false)  
    }, 1000);
  }

  get sessionTimeOut(): number {
    return this.sessionService.sessionTimeOut;
  }

  get dialog(): boolean {
    return this.sessionTimeOut <= 30 && this.sessionTimeOut > 0;
  }

  clearIntervals(): void {
    clearInterval(this.checkAuthInterval);
  }
}
